import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { buildAuthenticationBody } from "../util/build-authentication-body";

export const getGatewaysWithSources = async () => {
  try {
    const res = await fetch(`${appUrl()}/api/get-gateways-with-sources`, {
      method: "POST",
      headers: buildAuthenticationHeaders(),
      body: JSON.stringify({
        ...buildAuthenticationBody(),
      }),
    });
    if (res.status === 403) {
      navigateTo(Route.PERMISSION_DENIED);
      return;
    }
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    const response = await res.json();

    return response;
  } catch (err) {
    navigateTo(Route.SERVER_ERROR);
  }
};
